const PRIMARY_MENU_NAME_MAP = Object.freeze({
  房产: '房产管理',
  费用: '费用管理',
  OA: '流程审批',
  oa: '流程审批',
  停车: '停车管理',
  报修: '报修工单',
  巡检: '巡检管理',
  采购: '采购管理',
  设备: '物联设备',
  办公: '行政办公',
  合同: '合同管理',
  报表: '数据报表',
  优惠: '优惠管理',
  预约: '预约服务'
})

export function resolvePrimaryMenuName(menu) {
  const originalName = String(menu && menu.name ? menu.name : menu || '').trim()
  return PRIMARY_MENU_NAME_MAP[originalName] || originalName
}

export function isMenuNameLong(name, maxLength) {
  return Array.from(String(name || '').trim()).length > maxLength
}
